import { render } from "./LoginComponent.vue?vue&type=template&id=4ca1f31e&scoped=true&ts=true"
import script from "./LoginComponent.vue?vue&type=script&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&lang=ts"

import "./LoginComponent.vue?vue&type=style&index=0&id=4ca1f31e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca1f31e"]])

export default __exports__